import { Stack, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { Product, SubscriberProductResponseDto } from '@subflow/api-client';
import dynamic from 'next/dynamic';

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.up(1368)]: {
    padding: theme.spacing(5, 8),
  },
}));

type Props = {
  product: Product | SubscriberProductResponseDto;
  successCallback: () => void;
};

export default function SubscriptionDetailsCheckout({
  product,
  successCallback,
}: Props) {
  const SubscriptionForm = dynamic(
    () => import('../../../../components/listing/SubscriptionForm'),
    {
      ssr: false,
      loading: function NotReady() {
        return <CircularProgress />;
      },
    }
  );
  return (
    <RootStyle>
      <Stack spacing={3}>
        <Typography variant="h5">Pay with card</Typography>
        <SubscriptionForm product={product} successCallback={successCallback} />
      </Stack>
    </RootStyle>
  );
}
